import moment from "moment";
import { SessionService } from "../services";
const sessionService = new SessionService(process.env.REACT_APP_MIFIRMA_API)

/**
* @author Alan Aguilar
* @description Get the current date with format "dd/mmm/aaaa hh:mm:ss am/pm"
* @updatedDate 24-02-2022
* @returns {String}
*/
function getExactTimeFormated() {
  let today = new Date()
  let day = today.getDate()
  let month = today.getMonth() + 1
  let year = today.getFullYear()
  let hours = today.getHours()
  let minutes = today.getMinutes()
  let seconds = today.getSeconds()

  let dayString = ''
  let monthString = ''
  let yearString = `${year}`
  let hoursString = ''
  let minutesString = ''
  let secondsString = ''

  dayString = (day >= 10) ? `${day}` : `0${day}`

  if (month === 1) {
    monthString = 'Ene'
  } else if (month === 2) {
    monthString = 'Feb'
  } else if (month === 3) {
    monthString = 'Mar'
  } else if (month === 4) {
    monthString = 'Abr'
  } else if (month === 5) {
    monthString = 'May'
  } else if (month === 6) {
    monthString = 'Jun'
  } else if (month === 7) {
    monthString = 'Jul'
  } else if (month === 8) {
    monthString = 'Ago'
  } else if (month === 9) {
    monthString = 'Sep'
  } else if (month === 10) {
    monthString = 'Oct'
  } else if (month === 11) {
    monthString = 'Nov'
  } else if (month === 12) {
    monthString = 'Dic'
  }

  let ampm = (hours >= 12) ? 'pm' : 'am'
  let hoursResidual = hours % 12
  let hoursResult = hoursResidual || 12
  hoursString = (hoursResult >= 10) ? `${hoursResult}` : `0${hoursResult}`
  minutesString = (minutes >= 10) ? minutes : `0${minutes}`
  secondsString = (seconds >= 10) ? seconds : `0${seconds}`

  const dateConverted = `${dayString}/${monthString}/${yearString}`
  const timeConverted = `${hoursString}:${minutesString}:${secondsString} ${ampm}`
  const dateComplete = `${dateConverted} ${timeConverted}`
  return dateComplete
}

/**
* @author Alan Aguilar
* @description Get the user navegigator timezone with format "timezone (GMC+-0000)"
* @updatedDate 24-02-2022
* @returns {String}
*/
function getTimezoneFormated() {
  let today = new Date()
  let todayOffSet = today.toTimeString().slice(9, 17)
  let navegatorTimezone = Intl.DateTimeFormat().resolvedOptions().timeZone
  let timezone = `${navegatorTimezone} (${todayOffSet})`
  return timezone
}

/**
* @author Alan Aguilar
* @description Function to convert a date into another by timezone string
* @updatedDate 31-10-2022
* @param {Date} date
* @param {String} timezone
* @returns {String}
*/
function convertTimezone(date, timezone) {
  const result = new Date((typeof date === 'string' ? new Date(date) : date).toLocaleString('en-US', { timeZone: timezone }))
  return result
}

/**
* @author Alan Aguilar
* @description Get the exact time and navigator timezone in format "YYYY-MMM-DDThh:mm:ss-+0000"
* @updatedDate 04-11-2022
* @returns {String}
*/
async function getStampTimeAndTimezone() {
  let navegatorTimezone = Intl.DateTimeFormat().resolvedOptions().timeZone
  navegatorTimezone = (navegatorTimezone) ? navegatorTimezone : 'UTC'

  const serverDatetime = await sessionService.sessionGetServerTime(navegatorTimezone)
  const serverTime = (serverDatetime?.data?.serverTime) ? serverDatetime.data.serverTime : new Date()
  const today = (typeof serverTime === 'string') ? new Date(serverTime) : serverTime
  if (isNaN(today.getTime())) return false

  let day = today.getDate()
  let month = today.getMonth() + 1
  let year = today.getFullYear()
  let hours = today.getHours()
  let minutes = today.getMinutes()
  let seconds = today.getSeconds()

  let dayString = ''
  let monthString = ''
  let yearString = `${year}`
  let hoursString = ''
  let minutesString = ''
  let secondsString = ''

  if (month === 1) {
    monthString = 'Ene'
  } else if (month === 2) {
    monthString = 'Feb'
  } else if (month === 3) {
    monthString = 'Mar'
  } else if (month === 4) {
    monthString = 'Abr'
  } else if (month === 5) {
    monthString = 'May'
  } else if (month === 6) {
    monthString = 'Jun'
  } else if (month === 7) {
    monthString = 'Jul'
  } else if (month === 8) {
    monthString = 'Ago'
  } else if (month === 9) {
    monthString = 'Sep'
  } else if (month === 10) {
    monthString = 'Oct'
  } else if (month === 11) {
    monthString = 'Nov'
  } else if (month === 12) {
    monthString = 'Dic'
  }

  // Convertir fecha de acuerdo a la zona horaria del navegador del usuario
  dayString = (day >= 10) ? `${day}` : `0${day}`
  hoursString = (hours >= 10) ? hours : `0${hours}`
  minutesString = (minutes >= 10) ? minutes : `0${minutes}`
  secondsString = (seconds >= 10) ? seconds : `0${seconds}`
  let todayOffSet = today.toTimeString().slice(12, 17)
  let dateResult = `${yearString}-${monthString}-${dayString}T${hoursString}:${minutesString}:${secondsString}${todayOffSet}`

  return dateResult
}

/**
* @author Edgar Escobedo
* @description Get the navigator timezone 
* @updatedDate 11-04-2023
* @returns {String}
*/
function getNavigatorTimezone(){
  let navigatorTimezone = Intl.DateTimeFormat().resolvedOptions().timeZone
  return navigatorTimezone
}

/**
* @author Edgar Escobedo
* @description Convert string to date no timezone
* @updatedDate 26-04-2023
* @returns {String}
*/
function asyncStringToDateNoTimezone(date){
  let dateToConvert = date
  let dateToShow
  if(dateToConvert.includes('T')){
    let date = dateToConvert.split('T')[0]
    let hour = dateToConvert.split('T')[1]
    let year = date ? date.split('-')[0] : ''
    let month = date ? date.split('-')[1] : ''
    let day = date ? date.split('-')[2] : ''
    let hourClean = hour ? hour.split('-')[0] : ''
    let hourShow = hourClean && hourClean  !== '' ? hourClean.split(':')[0] : ''
    let minuteshow =hourClean && hourClean  !== ''  ? hourClean.split(':')[1] : ''
    let secondsShow = hourClean && (hourClean[0] === 0 || hourClean[0] === '0') ? hourClean[1]  : `${hourClean[0]}${hourClean[1]}`
    let horaCorrecta
    let minutosCorrectos
    let segundosCorrectos
    if(hourShow && hourShow !== ''){
      horaCorrecta = hourShow[0] === 0 ||  hourShow[0] === '0' ? Number(hourShow[1]) : Number(hourShow)
    }

    if(minuteshow && minuteshow !== ''){
      minutosCorrectos = minuteshow[0] === 0 ||  minuteshow[0] === '0' ? Number(minuteshow[1]) : Number(minuteshow)
    }

    
    if(secondsShow && secondsShow !== ''){
      segundosCorrectos = secondsShow ? Number(secondsShow) : ''
    }

    let monthConvert
    if(month){
      switch (month) {
        case '01':
          monthConvert = 0
          break;
          case '02':
          monthConvert = 1
          break;
          case '03':
            monthConvert = 2
        
        break;
        case '04':
          monthConvert = 3

        break;
        case '05':
          monthConvert = 4

          break;
          case '06':
            monthConvert = 5

          break;
          case '07':
            monthConvert = 6

          break;
          case '08':
            monthConvert = 7

          break;
          case '09':
            monthConvert = 8

          break;
          case '10':
            monthConvert = 9

          break;
          case '11':
            monthConvert = 10

          break;
          case '12':
            monthConvert = 11

        default:
          monthConvert = 1
          break ;
      }
    }
    dateToShow = new Date(Number(year), Number(monthConvert), Number(day), horaCorrecta, minutosCorrectos, segundosCorrectos)
  }
  return dateToShow
}

/**
* @author Edgar Escobedo
* @description Convert string date from BD to date without time
* @updatedDate 22-04-2024
* @returns {String}
*/
function convertDateNoTime(date){
  moment.locale("es");
  let dateSplit = date.split("T")[0]
  let dateConvert = moment(dateSplit).format("DD/MM/YYYY").replace(/\./g, "")    
  return dateConvert
}
export { getExactTimeFormated, getTimezoneFormated, getStampTimeAndTimezone, convertTimezone, getNavigatorTimezone, asyncStringToDateNoTimezone, convertDateNoTime }